var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footNote"},[_c('p',[_c('span',[_vm._v(" 公司名称：广州灵犀电子信息有限公司 ")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(" 公司地址：广州市南沙区环市大道南2号之广州南沙信息科技园软件楼南3039-5")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(" 联系电话：15323394632")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afdacba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/blog-foot.vue
// module id = null
// module chunks = 